@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

.editorWrapper {
  width: 100%;
  height: 100%;

  &.teamsApp {
    height: 30vh;

    :global(.CodeMirror) {
      min-height: unset;
    }
  }

  :global(.CodeMirror) {
    height: 100%;
    min-height: 300px;
    background-color: var(--background-soft);
    border: 1px solid var(--border-soft);
    @include border-radius-r2;
    color: var(--text-default);
    display: flex;
    flex-direction: column;
    @include typography-v2-body-base;
    width: 100%;
  }

  :global(.CodeMirror-selected) {
    background-color: transparent;
  }

  :global(.CodeMirror-selectedtext) {
    background-color: Highlight;
  }

  :global(div.CodeMirror.cm-s-easymde.CodeMirror-wrap) {
    @include typography-v2-body-base;
  }

  :global(.CodeMirror-cursor) {
    border-left: 1px solid var(--text-default);
  }

  :global(.CodeMirror-focused .CodeMirror-cursor) {
    border-left: 1px solid var(--text-default);
  }

  :global(.EasyMDEContainer) {
    position: relative;
    height: 100%;
  }

  :global(.editor-toolbar) {
    border: none;
    position: absolute;
    bottom: 8px;
    right: 8px;
    padding: 0;
    z-index: 2;
    background: transparent;
  }

  :global(.editor-toolbar button) {
    width: 16px;
    height: 16px;
    padding: 0;
  }

  :global(.editor-toolbar button svg) {
    width: 16px;
    height: 16px;
  }

  :global(.editor-toolbar button:hover) {
    background: transparent;
    border: none;
  }

  :global(.CodeMirror-vscrollbar) {
    @include custom-scroll-minimal;
  }

  &.isFullscreen :global(.CodeMirror) {
    width: 860px;
  }
}
